export const DISTRIBUTOR_SPECIAL_PRICE_MESSAGES_SUCCESS = {
  SAVE_SUCCESS: "Precio del producto especial guardado exitosamente.",
  DISABLE_SUCCESS: "Precio del producto especial deshabilitado exitosamente.",
  ENABLE_SUCCESS: "Precio del producto especial habilitado exitosamente.",
};

export const DISTRIBUTOR_SPECIAL_PRICE_MESSAGES_ERROR = {
  SAVE_ERROR:
    "Error al guardar el precio especial del producto. Por favor, inténtalo de nuevo.",
  DISABLE_ERROR:
    "Error al deshabilitar el precio especial del producto. Por favor, inténtalo de nuevo.",
  ENABLE_ERROR:
    "Error al habilitar el precio especial del producto. Por favor, inténtalo de nuevo.",
};
